<template>
  <div>
    <v-row no-gutters v-if="fieldsLoading">
      <v-col v-for="n in 9" :key="n" cols="12" sm="6" lg="3">
       <v-sheet class="mt-2">
        <v-skeleton-loader class="mx-auto" type="list-item"></v-skeleton-loader>
      </v-sheet>
      </v-col>
    </v-row>
    <form-data v-else :references.sync="formReferences" :model="employeeObj" ref="userReference"></form-data>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import FormTemplate from '../../components/FormTemplate'
export default {
  data () {
    return {
      employeeObj: {
        id: this.$route.params.user_id,
        isactive: true
      },
      fieldsLoading: false,
      listOfRoles: [],
      loading: false,
      MODULE_URL: 'users'
    }
  },
  components: {
    'form-data': FormTemplate
  },
  computed: {
    ...mapState(['FORM_TYPE', 'listOfGroups', 'listOfWarehouse']),
    formReferences () {
      return {
        title: this.$route.params.user_id ? this.$t('message.user.updateUser') : this.$t('message.user.addUser'),
        properties: [{
          model: 'firstname',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.user.firstName'),
          class: 'lg3 sm6',
          change: this.changesMade
        }, {
          model: 'lastname',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          label: this.$t('message.user.lastName'),
          class: 'lg3 sm6',
          change: this.changesMade
        }, {
          model: 'username',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.login.userName'),
          class: 'lg3 sm6',
          change: this.changesMade
        }, {
          model: 'email',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_emailValidation,
          label: this.$t('message.user.email'),
          class: 'lg3 sm6',
          change: this.changesMade
        }, {
          model: 'phone',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          label: this.$t('message.user.mobile'),
          class: 'lg3 sm6',
          change: this.changesMade
        }, {
          model: 'role',
          type: this.FORM_TYPE.SELECT,
          rules: this.$_requiredValidation,
          items: this.listOfUserRoles,
          select_text: 'name',
          select_value: 'id',
          label: this.$t('message.user.role'),
          class: 'lg3 sm6',
          change: this.changesMade
        }, {
          model: 'groupid',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          rules: this.$_requiredValidation,
          items: this.listOfGroups,
          is_list: true,
          click: (search) => this.supportingList(this.GROUPS, search, 'groupid'),
          term: 'group',
          select_text: 'name',
          select_value: 'id',
          label: this.$t('message.user.group'),
          class: 'lg3 sm6',
          change: this.changesMade
        }, {
          model: 'pin',
          type: this.FORM_TYPE.PASSWORD,
          rules: [],
          label: this.$t('message.user.pin'),
          class: 'lg3 sm6',
          change: this.changesMade
        }, {
          model: 'warehouseid',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          rules: this.$_requiredValidation,
          items: this.listOfWarehouse,
          is_list: true,
          click: (term) => this.supportingList(this.WAREHOUSES, term, 'warehouseid'),
          term: 'warehouse',
          select_text: 'name',
          select_value: 'id',
          label: this.$t('message.layout.warehouse'),
          class: 'lg3 sm6',
          change: this.changesMade
        }, {
          model: 'isactive',
          rules: [],
          type: this.FORM_TYPE.CHECKBOX,
          class: 'lg3 sm6 my-auto',
          label: this.$t('message.common.isActive')
        }, {
          model: 'sendmailnotification',
          rules: [],
          type: this.FORM_TYPE.CHECKBOX,
          class: 'lg3 sm6 my-auto',
          label: this.$t('message.user.sendMailNotify'),
          change: this.changesMade
        }, {
          model: 'externalemployeecode',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          label: this.$t('message.user.externalEmployeeCode'),
          class: 'lg3 sm6',
          change: this.changesMade
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.$route.params.user_id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: () => this.saveUpdateHandler(this.SAVE),
          loading: this.loading,
          is_show: true
        }, {
          name: 'close_handler',
          color: 'primary',
          label: this.$t('message.common.updateAndClose'),
          click: () => this.saveUpdateHandler(this.UPDATE_CLOSE),
          loading: this.loading,
          is_show: this.$route.params.user_id
        }, {
          name: 'back_to_list',
          color: 'info',
          // eslint-disable-next-line
          click: () => this.$router.push(`/${this.MODULE_URL}`),
          label: this.$t('message.common.backToList'),
          to: `/${this.MODULE_URL}`,
          is_show: true
        }, {
          name: 'delete_btn',
          color: 'error',
          label: this.$t('message.common.delete'),
          click: this.deleteHandler,
          is_show: this.$route.params.user_id
        }]
      }
    }
  },
  mounted () {
    let text = this.$t('message.common.deleteMsg')
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE_URL) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.$router.push(`/${this.MODULE_URL}`)
      }
    })
    this.$store.dispatch('getWarehouse')
      .then(() => {
        if (!this.employeeObj.id) this.setDefaultValues({ prop: 'warehouseid', list: this.listOfWarehouse })
      })
    this.$store.dispatch('getGroups')
    if (this.employeeObj.id) this.getSingleRecordHandler()
    this.$eventBus.$on('setItemInField', (data) => {
      let model = Object.assign({ ...this.employeeObj }, { [data.modelName]: data.recordId })
      this.employeeObj = model
    })
  },
  methods: {
    setDefaultValues (data) {
      let { list, prop } = data
      let item = list.find(x => x.isdefault)
      if (item) {
        let model = Object.assign({ ...this.employeeObj }, { [prop]: item.id })
        setTimeout(() => {
          this.employeeObj = model
        })
      }
    },
    getSingleRecordHandler () {
      this.fieldsLoading = true
      this.$_getSingleRecordHandler(`${this.MODULE_URL}/${this.employeeObj.id}`)
        .then((result) => {
          if (result.data) this.employeeObj = result.data
        })
        .finally(() => {
          this.fieldsLoading = false
        })
    },
    saveUpdateHandler (type) {
      if (this.$refs.userReference.$refs.validateForm.validate()) {
        this.loading = true
        let model = this.$formatter.cloneVariable(this.employeeObj)
        let url = this.MODULE_URL
        this.$_saveUpdateHandler(url, model)
          .then((response) => {
            this.$store.commit('isChangesMade', false)
            if (type === this.SAVE && !model.id) this.$router.push(`/${this.MODULE_URL}/actions/${response.id}`)
            else if (type === this.UPDATE_CLOSE) this.$router.push(`/${this.MODULE_URL}`)
          })
          .finally(() => {
            this.loading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    deleteHandler () {
      let ids = [this.employeeObj.id]
      let payload = { ids, url: `${this.MODULE_URL}/delete_multiple`, module: this.MODULE_URL }
      this.$store.commit('showDeleteDialog', payload)
    },
    supportingList (type, text, modelName) {
      text = this.$refs.userReference.$refs[text][0].lazySearch
      let model = { module: type, dialog: true, text, modelName }
      this.$store.commit('supportingList', model)
    },
    changesMade () {
      this.$store.commit('isChangesMade', true)
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.$store.state.isChangesMade) {
      next()
    } else {
      this.$store.commit('isChangesMade', true)
      this.$store.commit('changeLostDialog', true)
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('setItemInField')
  }
}
</script>
